import React from 'react';
import { CircularProgress } from '@material-ui/core';
import { PasslyButton } from '.';

interface IProps {
    className?: string;
    isDisabled: boolean;
    isLoad: boolean;
    buttonText: string;
    id?: string;
    onClick?: (e: React.ChangeEvent<HTMLFormElement>) => void;
    disableRipple?: boolean;
}

export const ButtonSubmit: React.SFC<IProps> = ({ id, className, isDisabled, buttonText, isLoad, onClick, disableRipple = true }) => {
    return (
        <PasslyButton id={id} onClick={onClick} className={className} color='primary' variant='contained' type='submit' disabled={isDisabled} disableRipple={disableRipple} isLoading={isLoad} >
            {buttonText}
        </PasslyButton>
    );
};

ButtonSubmit.defaultProps = {
    onClick: () => {}
};
